import React from 'react';

interface Mailbox {
  id: string;
  name: string;
  email: string;
}

interface MailboxSelectorProps {
  mailboxes: Mailbox[];
  selectedMailbox: string | null;
  onSelectMailbox: (mailboxId: string) => void;
}

const MailboxSelector: React.FC<MailboxSelectorProps> = ({
  mailboxes,
  selectedMailbox,
  onSelectMailbox
}) => {
  if (!mailboxes || mailboxes.length === 0) {
    return null;
  }
  
  return (
    <div className="flex items-center flex-1">
      <label className="font-medium mr-2" htmlFor="mailbox-select">
        Mailbox:
      </label>
      <select
        id="mailbox-select"
        value={selectedMailbox || ''}
        onChange={(e) => onSelectMailbox(e.target.value)}
        className="max-w-[300px] bg-white border border-gray-300 rounded-md py-2 px-3 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
      >
        {mailboxes.map(mailbox => (
          <option key={mailbox.id} value={mailbox.id}>
            {mailbox.name} ({mailbox.email})
          </option>
        ))}
      </select>
    </div>
  );
};

export default MailboxSelector;
